import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import '@/components/globals'

Vue.config.productionTip = false

import TestAttrs from '@/directives/test'
Vue.directive('test', TestAttrs)

import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo)

import vClickOutside from 'v-click-outside'
Vue.use(vClickOutside)

import Clipboard from 'v-clipboard'
Vue.use(Clipboard)

import Toasted from 'vue-toasted'
Vue.use(Toasted, {
  position: 'top-center',
  theme: 'toasted--custom',
  iconPack: 'callback',
  singleton: true
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
